export default __webpack_public_path__ + "static/media/hmd_background_m2.069fff19.jpg";